import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { formatCurrency } from "../helpers/formatter";
import { useDispatch } from "react-redux";
import { shareCrmLink } from "../redux/actions/policyAction";
import { pathOr } from "ramda";

const AssignmentCard = (props) => {
    const {policy} = props
    const dispatch = useDispatch();
    const user = pathOr(false, ['user'], props)
    const shareLink = () => {
        dispatch(shareCrmLink({policyNumber: policy.policyNumber}))
    }
    return(
        <div style={{ borderStyle: 'solid',borderWidth: 1, borderColor: '#489135',borderRadius: 16,  background: '#EDF6EB', marginTop: 12,  }}>
        <Grid columns={{ xs: 4, sm: 8, md: 12 }} container spacing={2} style={{  padding: 30 }}>
            <Grid size={5} spacing={2}>
                <div>
                    <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                        <Typography>Policy Assignment</Typography>
                    </div>
                    <Typography variant='caption'>Enjoy risk coverage  at zero cost. </Typography>
                </div>
            </Grid>
            <Grid spacing={2}>
                <div>
                    <Typography color='#40812F' variant='h5' align='center'>₹ {formatCurrency(policy.surrenderValue)}</Typography>
                    <Typography align='center' variant='body2'>Surrender Value</Typography>
                </div>
            </Grid>
            {user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success'>Avail Now</Button>
                        </div>
                    </Grid>
                )}
                {!user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success' onClick={() => shareLink()}>Share Link</Button>
                        </div>
                    </Grid>
                )}
        </Grid>
    </div>
    )
}

export default AssignmentCard